export { init, type HyperShaderConfig, type TransitionConfig } from "./hyper-shader.js";
export { SHADER_NAMES, type ShaderName } from "./shaders/registry.js";
